// extracted by mini-css-extract-plugin
export default {"container":"Y8w1o","header":"srIox","footer":"GJON6"};